<template>
  <div class="auto-split">
    <!-- 自动/手动拆分预览 -->
    <el-dialog 
      :title="titleSplit" 
      top="18vh" 
      :visible.sync="previewDialog" 
      class="preview-dialog"
      :before-close="closePreviewDialog"
      width="832px">
      <div class="border"></div>
      <div class="table">
        <el-table 
          ref="table" 
          :data="previewList" 
          style="width: 100%">
          <el-table-column 
            v-for="(item, index) in previewTitleList" 
            :key="index" 
            :label="item.label" 
            :prop="item.prop"
            :min-width="item.width" 
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closePreviewDialog">取消</el-button>
        <el-button class="btn-blue" @click="savePreview">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 自动/手动拆分预览弹框开关
    previewDialog: {
      type: Boolean,
      default: false
    },
    // 自动/手动拆分预览标题
    titleSplit: {
      type: String,
      default: '自动拆分预览'
    },
    // 预览列表
    previewList: {
      type: Array,
      default: []
    },
    previewTitleList: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
    }
  },

  created() {},

  methods: {
    closePreviewDialog() {
      this.$emit('onClosePreviewDialog')
    },

    savePreview() {
      this.$emit('onSavePreview')
    }
  }
}
</script>

<style lang='scss'>
.preview-dialog {
  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
    .el-dialog__body {
      padding: 0px;
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
      .table {
        padding: 20px;
      }
    }
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
